// @flow

import config from 'config/app.config';
import { ActionsObservable, combineEpics } from 'redux-observable';
import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { catchError, filter, map, switchMap } from 'rxjs/operators';

import { GET_CONTENT, GET_CONTENT_DONE } from '../actions';
import type { ContentActions } from '../types';

const getContentEpic = (action$: ActionsObservable<ContentActions>, state$: any) =>
  action$.pipe(
    filter(action => action.type === GET_CONTENT),
    switchMap((request) => {
      const contentObj = state$.value.content.contents.find(item => item.key === request.payload);
      const lang = state$.value.i18n.language;

      if (contentObj && contentObj.content[lang] && contentObj.content[lang] !== '') {
        return of({
          type: GET_CONTENT_DONE,
          payload: { key: request.payload, content: contentObj.content[lang], lang },
        });
      }

      if (contentObj && contentObj.url !== '') {
        return ajax({
          url: contentObj.url.replace('{lang}', state$.value.i18n.language).replace('{licence}', config.licence),
          responseType: 'text',
        }).pipe(
          map((response) => {
            return {
              type: GET_CONTENT_DONE,
              payload: { key: request.payload, content: response.response, lang },
            };
          }),
          catchError(() =>
            of({
              type: GET_CONTENT_DONE,
              payload: { key: request.payload, content: '', lang },
            })),
        );
      }

      return of({
        type: GET_CONTENT_DONE,
        payload: { key: request.payload, content: '', lang },
      });
    }),
  );

export const contentEpics = combineEpics(getContentEpic);
